import React, { useEffect, useState } from 'react';
import { Divider } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  CommonPagination,
  ScreenContainer,
} from '../../CommonComponents';
import {
  getAllSites, getFilters,
  getFilterSitesByAuditorAction, getSitesDataByEstimateId, updatePrimaryQuery,
  updateSearchQuery,
  updateSitesAuditorVisibility,
} from '../../redux/actions/sites';
import SitesFilter from '../../CommonComponents/SitesFilter/SitesFilter';
import SiteAssignTable from './SiteAssignTable'
import PrimaryFilters from '../../CommonComponents/PrimaryFilters';
import FallbackCard from '../../CommonComponents/FallbackCard';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SiteAssign = ({
  getAllSitesAction, totalSitePages, updateQuery, primaryQuery, searchQuery,
  fetchSites, getFilter, updateSitesAuditorVisibilityFn, filterSitesByAuditorAction,
}) => {
  const query = useQuery();
  const history = useHistory()
  const page = parseInt(query.get('page') || '1', 10);
  const [showSites, enableSites] = useState(false);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const pno = query.get('page')
    if (showSites && pno) getAllSitesAction(page, searchQuery, primaryQuery);
  }, [query, getAllSitesAction, getFilter, searchQuery, primaryQuery, showSites, page]);

  const fetchAllSite = (val) => {
    if (query.has('estimateId')) {
      query.set('estimateId', val)
    } else {
      query.append('estimateId', val)
    }
    query.delete('page')
    history.push('/sites-reported')
    updateQuery(query.toString())
    fetchSites(val);
    enableSites(true);
  }

  const updateSitesVisibility = async (siteIds) => {
    await updateSitesAuditorVisibilityFn(siteIds, page, primaryQuery, searchQuery)
  }

  const handleAuditorActionFilter = async (status) => {
    filterSitesByAuditorAction(page, primaryQuery, searchQuery, status);
  }

  const user = JSON.parse(localStorage.getItem('user'))

  return (
    <ScreenContainer title="Reported Sites">
      {user?.userType === 'buyer' && user?.id !== 96 && open
        ? (
          <>
            <Alert
              severity="info"
              action={(
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
          )}
            >
              You can only see sites of state
              {' '}
              {user.depended_field?.length > 0 ? user.depended_field.join(', ') : ''}
              .
            </Alert>
            <br />
          </>
        )
        : null}
      <PrimaryFilters
        visibleProduct
        visibleEstimate
        fetchFunction={fetchAllSite}
        location="allsites"
        showFetchButton
      />
      <br />
      {showSites
        ? (
          <>
            <SitesFilter currentLocation="sites-reported" />
            <div className="row">
              <Divider />
              <div className="col-12">
                <br />
                <SiteAssignTable
                  updateSitesAuditorVisibility={updateSitesVisibility}
                  handleAuditorActionFilter={handleAuditorActionFilter}
                />
                {totalSitePages > 1 ? (
                  <CommonPagination
                    baseUrl="sites-reported"
                    totalPages={totalSitePages}
                  />
                ) : null}
                <br />
              </div>
            </div>
          </>
        )
        : <FallbackCard text="Fetch the sites to start" />}
    </ScreenContainer>
  );
};

const mapState = (state) => ({
  totalSitePages: state.sites.totalSitePages,
  searchQuery: state.sites.searchQuery,
  primaryQuery: state.sites.primaryQuery,
});

const mapActions = {
  getAllSitesAction: getAllSites,
  filterSitesByAuditorAction: getFilterSitesByAuditorAction,
  updateQuery: updatePrimaryQuery,
  updateSearchQueryFn: updateSearchQuery,
  fetchSites: getSitesDataByEstimateId,
  getFilter: getFilters,
  updateSitesAuditorVisibilityFn: updateSitesAuditorVisibility,
};

export default connect(mapState, mapActions)(SiteAssign);
